export default (theme, spacing) => ({
  defaultProps: {
    spacing,
  },
});
